import { render, staticRenderFns } from "./production-cell-fine.vue?vue&type=template&id=0f0f1b3b&scoped=true&"
import script from "./production-cell-fine.vue?vue&type=script&lang=js&"
export * from "./production-cell-fine.vue?vue&type=script&lang=js&"
import style0 from "./production-cell-fine.vue?vue&type=style&index=0&id=0f0f1b3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0f1b3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f0f1b3b')) {
      api.createRecord('0f0f1b3b', component.options)
    } else {
      api.reload('0f0f1b3b', component.options)
    }
    module.hot.accept("./production-cell-fine.vue?vue&type=template&id=0f0f1b3b&scoped=true&", function () {
      api.rerender('0f0f1b3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/production-cell-fine.vue"
export default component.exports